/**
 * Created by Dong on 2017/7/31.
 */
import api from '../../utils/api'
import * as types from '../constants/ActionTypes'


/*
 * ÉÏ´« ¿ìËÙÈ¡Ö¤ Í¼Æ¬
 * */
let uploadImg_Quick = (image, flowId)=> {
    let url = '/lossAss/v1.0/shotPics';
    return dispatch=> {
        dispatch(uploadImg_QuickInitiate());
        return api(url)
            .post({
                image: image,
                flowId: flowId
            })
            .then(resData=> dispatch(uploadImg_QuickFinish(resData))).catch(err=> {
                dispatch(uploadImg_QuickFailed())
            })
    }
};
let uploadImg_QuickInitiate = ()=> {
    return {
        type: types.UPLOAD_IMG_QUICK_INITIATE,
        payload: {}
    }
};
let uploadImg_QuickFinish = (resData)=> {
    let {errCode,result}=resData;
    if (errCode == 0) {
        return {
            // type: types.UPLOAD_IMG_QUICK_FINISH,
            payload: {result: result, errCode:0}
        }
    } else {
        return {
            // type: types.UPLOAD_IMG_QUICK_FAILED,
            payload: {}
        }
    }

};
let uploadImg_QuickFailed = ()=> {
    return {
        type: types.UPLOAD_IMG_QUICK_FAILED,
        payload: {}
    }
};


export default{
    uploadImg_Quick,
}